import { Eye } from "lucide-react";
import { t } from "../strings.js";
import { downloadFromUrl } from "../lib/downloads";
import { SendToCauldronButton } from "./SendToCauldronButton";

// >>> HER TICKET #127: THE SEAL SHE MADE, ON THE SURFACE SHE COMES BACK TO. <<<
//
// This is what My Room draws when a shelf row is one of her own generated seals.
//
// **IT SHIPPED WITH ONE DOWNLOAD, CALLED "Download PDF", WIRED TO `pdf/description`** — and the
// description PDF carries the title, the intention, the names, their meanings and the description,
// and **NO SEAL IMAGE ANYWHERE IN IT**. So a member who made nine seals and came back for them
// tapped the only download on the screen and got a sheet of text. R38/R165 in its purest form: the
// capability is built, served and translated (`/pdf/image` answers 200 with a real 2.3MB seal
// page), and the one surface she returns to had no door to it.
//
// **THE TWO LABELS ARE THE SEAL CREATOR'S OWN CATALOG ROWS**, never new copy: one act must not be
// named two ways on two screens (R28/R29), and those two are already in both languages.
//
// **BOTH GO THROUGH `downloadFromUrl`**, which reads the ANSWER — this route composes 401, 404 and
// 500 in its own words, and an anchor cannot read a refusal (R101/R88).
//
// It is HOOKLESS, so `scripts/seal-download.mjs` can CALL it rather than reading App.tsx as text.
export function SealShelfView({ sealId, title, language }: {
  sealId: string;
  title: string;
  language: string;
}) {
  const pdf = (kind: "image" | "description") => `/api/seals/generated/${sealId}/pdf/${kind}`;
  return (
    <div className="chart-report__wrap shelf-seal-view">
      <div className="reader__toolbar">
        <span><Eye size={16} /> Your seal</span>
        <div className="chart-report__actions">
          <button type="button" className="reading-actions__link" onClick={() => void downloadFromUrl(pdf("image"))}>{t(language, "seal.downloadImage")}</button>
          <button type="button" className="reading-actions__link" onClick={() => void downloadFromUrl(pdf("description"))}>{t(language, "seal.downloadDescription")}</button>
          {/* MR-C2: a member's own Seal Creator seal can ride into a compiled working. */}
          <SendToCauldronButton
            language={language}
            kind="seal"
            title={title}
            data={{ type: "seal", title, memberSeal: { id: sealId, title }, sealImageUrl: `/api/seals/generated/${sealId}/image` }}
          />
        </div>
      </div>
      <img className="shelf-seal-view__img" src={`/api/seals/generated/${sealId}/image`} alt="Your seal" />
    </div>
  );
}
